import React from 'react';
import musik from '../asset/musik.png';
import profil from '../asset/profil.png';
import weather from '../asset/weather.png';

const Projects = () => {
  return (
    <section id="projects" className="bg-custom-green2 py-20 text-custom-yellow">
      <div className="container mx-auto text-center">
        <h2 className="text-5xl font-bold mb-8">My Projects</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-4 bg-custom-yellow rounded-lg py-6 shadow-2xl">
            <img src={`${musik}`} alt="Music App" className="w-full "/>
            <h3 className="mt-10 font-semibold text-black">Membuat musik web menggunakan Figma</h3>
          </div>
          <div className="p-4 bg-custom-yellow rounded-lg shadow-2xl">
            <img src={`${profil}`} alt="Weather App" className=" w-full rounded-lg  "/>
            <h3 className="mt-10 font-semibold text-black">Membuat desain profil menggunakan Node JS</h3>
          </div>
          <div className="p-4 bg-custom-yellow rounded-lg shadow-2xl">
            <img src={`${weather}`} alt="Profile Design" className="w-full rounded-lg"/>
            <h3 className="mt-10 font-semibold text-black">Membuat weather menggunakan Figma</h3>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Projects;
